import { toMap, getAppService } from "../../../../HA";
import { Container } from "../Container/Container";
import { FlexContainer } from "../Container/FlexContainer";
import { CFlexContainer } from "../Container/CFlexContainer";
import { Div } from "../Div";
import { UImg } from "../Image/UImg";
import { Window } from "../Container/Window/Window";
import { Slider } from "../Container/List/Slider";
import { App as ServiceApp } from "../../Service/App";
import type { FSApp } from "../../Entity/FSApp";

export class Gallery extends Container {

    protected createSelf() {
        super.createSelf();
        this.addClass("gallery")
        const gallery = this.get("medias");
        const total = gallery.length;
        const fc = this.get("fc");
        const cont = fc ? new FlexContainer() : new CFlexContainer();
        const ctac = new Div({class: "gcta", txt : total + " image(s)"});

        const uimg = new UImg({mid: gallery[0]});
        uimg.appendChild(ctac);

        cont.appendChild(uimg);

        cont.onClick(() => {
            this.handleClick();
        });

        this.appendChild(cont);
    }

    private closeModal(): void {
        getAppService().closeFSApp(this.getAppId());
    }

    private handleClick(): void {
        const app2 = ServiceApp.createFSApp(this.loadGallery());
        this.setAppId(app2.getId());
        this.showModal(app2);
    }

    private loadGallery(): CFlexContainer {
        const cont = new Window(toMap({
            wcancel: () => {
                this.closeModal();
            },
        }));

        const sc = [];
        const name = this.get("name");
        const medias = this.get("medias");
        const t = medias.length;
        let p = 1;
        medias.forEach((id: string) => {
            sc.push({
                "t": "div",
                "class": "imgc",
                "c": [
                    {
                        "t": "uimg",
                        "ti": name + " " + (p++) + "/" + t,
                        "mid": id
                    }
                ]
            })
        });

        cont.appendChild(new Slider({
            "t": "slider",
            "class": "swiper",
            "pagination": true,
            "prev": true,
            "next": true,
            "scrollbar": true,
            "sc": sc
        }))
        return cont;
    }

    private showModal(app: FSApp) {
        getAppService().showFSApp(app);
    }

    private setAppId(id: string) {
        return this.addToData("_appId", id);
    }

    private getAppId(): string {
        return this.get("_appId");
    }
}
